
import ChangePassword from '~/pages/_lang/changePassword'
export default ChangePassword
